import { getTestIds } from 'seagull/utils/TestIds';
export const editContactModalTextsPath = 'components.editContactModal';
export const CONTACT_FIELD_NAME = 'contact';
export const CONTACT_FORM_TEST_ID = 'edit-contact-form';
export const GetEditContactModalTID = (parentTestId)=>getTestIds(parentTestId);
